.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #c7d8df;
  border-bottom-left-radius: var(--border-radius-xs);
  border-bottom-right-radius: var(--border-radius-xs);
  border-top: 0;
  padding: var(--space-s);
  margin-bottom: var(--space-m);
  margin-top: calc(-1 * var(--space-m) - 1px);
  box-shadow: inset 0 0 4px 1px #eee, 0 0 2px 1px #eee;
}

.dialog {
  &:focus {
    outline: none;
  }
}

.paramsList {
  margin: 0;
  padding: 0;
}
